module.exports = __webpack_public_path__ + "media/bieke.7c395fca.mp4";